export default __webpack_public_path__ + "static/media/learose2.29d26c5d.jpg";